<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>{{reportCustomComponentFooterManageInfo.componentName}}
              <span>{{$t('reportCustomComponentFooterManage.statistics')}}</span>
            </span>
            <div>
              <el-button type="default" size="small" @click="_goBack()">{{$t('common.back')}}</el-button>
              <el-button type="primary" size="small" @click="_openAddReportCustomComponentFooterModal()">
                <i class="el-icon-plus"></i>{{$t('common.add')}}
              </el-button>
            </div>
          </div>
          <div class="table-container">
            <el-table
              :data="reportCustomComponentFooterManageInfo.reportCustomComponentFooters"
              border
              style="width: 100%">
              <el-table-column
                prop="footerId"
                :label="$t('reportCustomComponentFooterManage.id')"
                align="center">
              </el-table-column>
              <el-table-column
                prop="name"
                :label="$t('reportCustomComponentFooterManage.name')"
                align="center">
              </el-table-column>
              <el-table-column
                prop="queryModel"
                :label="$t('reportCustomComponentFooterManage.queryMethod')"
                align="center">
              </el-table-column>
              <el-table-column
                prop="remark"
                :label="$t('reportCustomComponentFooterManage.description')"
                align="center">
              </el-table-column>
              <el-table-column
                :label="$t('reportCustomComponentFooterManage.operation')"
                align="center"
                width="200">
                <template slot-scope="scope">
                  <el-button-group>
                    <el-button
                      size="mini"
                      @click="_openEditReportCustomComponentFooterModel(scope.row)">
                      {{$t('common.edit')}}
                    </el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="_openDeleteReportCustomComponentFooterModel(scope.row)">
                      {{$t('common.delete')}}
                    </el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-container">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                layout="total, prev, pager, next, jumper"
                :total="reportCustomComponentFooterManageInfo.total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <add-report-custom-component-footer ref="addComponentFooter"></add-report-custom-component-footer>
    <edit-report-custom-component-footer ref="editComponentFooter"></edit-report-custom-component-footer>
    <delete-report-custom-component-footer ref="deleteComponentFooter"></delete-report-custom-component-footer>
  </div>
</template>

<script>
import { listReportCustomComponentFooter } from '@/api/dev/reportCustomComponentFooterApi'
import AddReportCustomComponentFooter from '@/components/dev/addReportCustomComponentFooter/addReportCustomComponentFooter'
import EditReportCustomComponentFooter from '@/components/dev/editReportCustomComponentFooter/editReportCustomComponentFooter'
import DeleteReportCustomComponentFooter from '@/components/dev/deleteReportCustomComponentFooter/deleteReportCustomComponentFooter'

export default {
  name: 'ReportCustomComponentFooterManage',
  components: {
    AddReportCustomComponentFooter,
    EditReportCustomComponentFooter,
    DeleteReportCustomComponentFooter
  },
  data() {
    return {
      reportCustomComponentFooterManageInfo: {
        reportCustomComponentFooters: [],
        total: 0,
        componentName: '',
        conditions: {
          componentId: '',
          name: '',
          queryModel: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this.reportCustomComponentFooterManageInfo.conditions.componentId = this.$route.query.componentId
    this.reportCustomComponentFooterManageInfo.componentName = this.$route.query.componentName
    this._listReportCustomComponentFooters(this.currentPage, this.pageSize)
  },
  methods: {
    async _listReportCustomComponentFooters(page, rows) {
      try {
        const params = {
          ...this.reportCustomComponentFooterManageInfo.conditions,
          page,
          row: rows
        }
        const res = await listReportCustomComponentFooter(params)
        this.reportCustomComponentFooterManageInfo.reportCustomComponentFooters = res.data
        this.reportCustomComponentFooterManageInfo.total = res.total
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listReportCustomComponentFooters(this.currentPage, this.pageSize)
    },
    _openAddReportCustomComponentFooterModal() {
      this.$refs.addComponentFooter.open({
        componentId: this.reportCustomComponentFooterManageInfo.conditions.componentId
      })
    },
    _openEditReportCustomComponentFooterModel(row) {
      this.$refs.editComponentFooter.open(row)
    },
    _openDeleteReportCustomComponentFooterModel(row) {
      this.$refs.deleteComponentFooter.open(row)
    },
    _goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.table-container {
  margin-top: 20px;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>